module.exports = __webpack_public_path__ + "img/logo.97a9318f.png";